module.exports = __webpack_public_path__ + "static/media/share-screen.b8c54019.svg";